import { Component, Prop, h, Host, Event, EventEmitter } from '@stencil/core';
import { LanguageSelectorOption } from './pn-language-selector-types';

@Component({
  tag: 'pn-language-selector-option',
  styleUrl: 'pn-language-selector-option.scss',
})
export class PnlanguageSelectorOption {
  /** What you write in the comment block above each prop is what ends up in the description fields in the prop table in the documentation */
  @Prop() name: string = '';
  @Prop() code: string = '';
  @Prop() url: string = '';
  @Prop() selected: boolean = false;
  @Prop() currentLanguage: string;

  private spanEl!: HTMLElement;

  @Event() setCurrentLanguage: EventEmitter;
  onOptionClick() {
    const currentlanguage: LanguageSelectorOption = {
      name: this.name,
      code: this.code,
      url: this.url,
      current: true,
    };
    this.setCurrentLanguage.emit(currentlanguage);
  }

  componentDidLoad() {
    if (this.spanEl) {
      this.spanEl.setAttribute("xml:lang", this.code);
    }
  }

  render() {
    return (
      <Host role="listitem" selected={this.selected + ''} code={this.code} name={this.name}>
        {!this.url ? (
          <button class="languageselector-button" data-langcode={this.code} onClick={this.onOptionClick.bind(this)}>
            <span class="languageselector-radio-outer">
              <span class="languageselector-radio-inner"></span>
            </span>
            <span ref={(el) => (this.spanEl = el as HTMLElement)} lang={this.code} class="languageselector-itemtext">
              {this.name} - {this.code}
            </span>
          </button>
        ) : (
          <a href={this.url} target="_self" class="languageselector-link" data-langcode={this.code}>
            <span class="languageselector-radio-outer">
              <span class="languageselector-radio-inner"></span>
            </span>
            <span ref={(el) => (this.spanEl = el as HTMLElement)} lang={this.code} class="languageselector-itemtext">
              {this.name} - {this.code}
            </span>
          </a>
        )}
      </Host>
    );
  }
}
